import { render } from "./TrainingPrograms.vue?vue&type=template&id=bfee5584&scoped=true"
import script from "./TrainingPrograms.vue?vue&type=script&lang=js"
export * from "./TrainingPrograms.vue?vue&type=script&lang=js"

import "./TrainingPrograms.vue?vue&type=style&index=0&id=bfee5584&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfee5584"]])

export default __exports__